module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av507-5f00267e5291c6f3bccd8593f05569b0.jpg";